export const REGULATORY_TITLE_LENGTH = 124
export const REGULATORY_CONTENT_LENGTH = 193
export const INFO_TITLE_LENGTH = 163
export const INFO_CONTENT_LENGTH = 193
export const RESOURCE_TITLE_LENGTH = 124
export const PRODUCT_TITLE_LENGTH = 124
